import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import LucideSymbolIcon from '../../components/icons/LucideSymbolIcon';
import PasswordRecoveryLayout, {
  AUTH_FIELD_CLASS,
  RecoveryAlert,
  RecoveryAuthField,
  RecoveryPrimaryButton,
} from '../../components/auth/PasswordRecoveryLayout';
import { requestPasswordReset } from '../../services/api';

function isValidEmail(value: string) {
  const v = value.trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    if (!isValidEmail(email)) {
      setError('Adresse e-mail invalide.');
      return;
    }
    setLoading(true);
    try {
      await requestPasswordReset(email.trim().toLowerCase());
      navigate(`/verify-password-reset?email=${encodeURIComponent(email.trim().toLowerCase())}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Demande impossible.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PasswordRecoveryLayout
      activeStep={1}
      compact
      title="Mot de passe oublié"
      description="Indiquez l’adresse e-mail de votre compte. Si elle existe, vous recevrez un code à 6 caractères."
    >
      <form onSubmit={(e) => void handleSubmit(e)} className="space-y-3">
        <RecoveryAuthField label="Adresse e-mail" icon="mail" id="fp-email">
          <input
            id="fp-email"
            type="email"
            autoComplete="email"
            className={AUTH_FIELD_CLASS}
            value={email}
            onChange={(ev) => setEmail(ev.target.value)}
            placeholder="vous@exemple.cd"
          />
        </RecoveryAuthField>

        {error ? <RecoveryAlert variant="error">{error}</RecoveryAlert> : null}

        <p className="text-[11px] leading-snug text-on-surface-variant sm:text-xs">
          Vérifiez vos spams si le message tarde. Le code expire après un délai limité.
        </p>

        <RecoveryPrimaryButton loading={loading} disabled={loading}>
          {loading ? (
            'Envoi en cours…'
          ) : (
            <>
              Recevoir le code
              <LucideSymbolIcon name="arrow_forward" tone="inherit" size={18} className="text-white" />
            </>
          )}
        </RecoveryPrimaryButton>
      </form>
    </PasswordRecoveryLayout>
  );
}
